export const FIXED_COLUMNS_COUNT = 3;

interface CampaignsTableColumnConfig {
    id: CampaignsTableColumn;
    width: number;
    stickyLeft: boolean;
    trlKey: string;
    tooltipTrlKey?: string;
}

export enum CampaignsTableColumn {
    Actions = 'actions',
    Switch = 'switch',
    CampaignName = 'campaignName',
    Banners = 'banners',
    ProductType = 'productType',
    Areas = 'areas',
    Budget = 'budget',
    BudgetRemaining = 'budgetRemaining',
    BudgetSpent = 'budgetSpent',
    Bid = 'bid',
    AveragePricePerClick = 'averagePricePerClick',
    Clicks = 'clicks',
    Shows = 'shows',
    CTR = 'ctr',
    VacancyViews = 'vacancyViews',
    Responses = 'responses',
    ResponsesBeforeClickme = 'responsesBeforeClickme',
    Sources = 'sources',
    BiddingStrategy = 'biddingStrategy',
    StartAt = 'startAt',
    EndAt = 'endAt',
    ProfessionalRoles = 'professionalRoles',
    VacancyManager = 'vacancyManager',
    CreatedBy = 'createdBy',
}

export const CAMPAIGNS_TABLE_COLUMNS_MAP: Record<CampaignsTableColumn, CampaignsTableColumnConfig> = {
    [CampaignsTableColumn.Actions]: {
        id: CampaignsTableColumn.Actions,
        width: 36,
        stickyLeft: true,
        trlKey: '',
    },
    [CampaignsTableColumn.Switch]: {
        id: CampaignsTableColumn.Switch,
        width: 52,
        stickyLeft: true,
        trlKey: '',
    },
    [CampaignsTableColumn.CampaignName]: {
        id: CampaignsTableColumn.CampaignName,
        width: 240,
        stickyLeft: true,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.campaign',
    },
    [CampaignsTableColumn.Banners]: {
        id: CampaignsTableColumn.Banners,
        width: 84,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.banners',
    },
    [CampaignsTableColumn.ProductType]: {
        id: CampaignsTableColumn.ProductType,
        width: 166,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.productType',
    },
    [CampaignsTableColumn.Areas]: {
        id: CampaignsTableColumn.Areas,
        width: 142,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.areas',
    },
    [CampaignsTableColumn.Budget]: {
        id: CampaignsTableColumn.Budget,
        width: 120,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.budget',
    },
    [CampaignsTableColumn.BudgetRemaining]: {
        id: CampaignsTableColumn.BudgetRemaining,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.budgetRemaining',
    },
    [CampaignsTableColumn.BudgetSpent]: {
        id: CampaignsTableColumn.BudgetSpent,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.budgetSpent',
    },
    [CampaignsTableColumn.Bid]: {
        id: CampaignsTableColumn.Bid,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.bid',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.bidTooltip',
    },
    [CampaignsTableColumn.AveragePricePerClick]: {
        id: CampaignsTableColumn.AveragePricePerClick,
        width: 114,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.averagePricePerClick',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.averagePricePerClickTooltip',
    },
    [CampaignsTableColumn.Clicks]: {
        id: CampaignsTableColumn.Clicks,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.clicks',
    },
    [CampaignsTableColumn.Shows]: {
        id: CampaignsTableColumn.Shows,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.shows',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.showsTooltip',
    },
    [CampaignsTableColumn.CTR]: {
        id: CampaignsTableColumn.CTR,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.ctr',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.ctrTooltip',
    },
    [CampaignsTableColumn.VacancyViews]: {
        id: CampaignsTableColumn.VacancyViews,
        width: 200,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.vacancyViews',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.vacancyViewsTooltip',
    },
    [CampaignsTableColumn.Responses]: {
        id: CampaignsTableColumn.Responses,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.responses',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.responsesTooltip',
    },
    [CampaignsTableColumn.ResponsesBeforeClickme]: {
        id: CampaignsTableColumn.ResponsesBeforeClickme,
        width: 116,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.responsesBeforeClickme',
        tooltipTrlKey: 'CampaignsDashboard.CampaignsTable.column.responsesBeforeClickmeTooltip',
    },
    [CampaignsTableColumn.Sources]: {
        id: CampaignsTableColumn.Sources,
        width: 88,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.sources',
    },
    [CampaignsTableColumn.BiddingStrategy]: {
        id: CampaignsTableColumn.BiddingStrategy,
        width: 136,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.biddingStrategy',
    },
    [CampaignsTableColumn.StartAt]: {
        id: CampaignsTableColumn.StartAt,
        width: 100,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.startAt',
    },
    [CampaignsTableColumn.EndAt]: {
        id: CampaignsTableColumn.EndAt,
        width: 148,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.endAt',
    },
    [CampaignsTableColumn.ProfessionalRoles]: {
        id: CampaignsTableColumn.ProfessionalRoles,
        width: 132,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.professionalRoles',
    },
    [CampaignsTableColumn.VacancyManager]: {
        id: CampaignsTableColumn.VacancyManager,
        width: 170,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.vacancyManager',
    },
    [CampaignsTableColumn.CreatedBy]: {
        id: CampaignsTableColumn.CreatedBy,
        width: 170,
        stickyLeft: false,
        trlKey: 'CampaignsDashboard.CampaignsTable.column.createdBy',
    },
};

export const CAMPAIGN_CARD_VISIBLE_COLUMNS: CampaignsTableColumn[] = [
    CampaignsTableColumn.ProductType,
    CampaignsTableColumn.Banners,
    CampaignsTableColumn.Areas,
    CampaignsTableColumn.Budget,
    CampaignsTableColumn.BudgetRemaining,
    CampaignsTableColumn.BudgetSpent,
];

export const CAMPAIGN_CARD_DETAILS_COLUMNS: CampaignsTableColumn[] = [
    ...CAMPAIGN_CARD_VISIBLE_COLUMNS,
    CampaignsTableColumn.Bid,
    CampaignsTableColumn.AveragePricePerClick,
    CampaignsTableColumn.Clicks,
    CampaignsTableColumn.Shows,
    CampaignsTableColumn.CTR,
    CampaignsTableColumn.VacancyViews,
    CampaignsTableColumn.Responses,
    CampaignsTableColumn.ResponsesBeforeClickme,
    CampaignsTableColumn.Sources,
    CampaignsTableColumn.BiddingStrategy,
    CampaignsTableColumn.StartAt,
    CampaignsTableColumn.EndAt,
    CampaignsTableColumn.ProfessionalRoles,
    CampaignsTableColumn.CreatedBy,
];

export const CAMPAIGNS_TABLE_COLUMNS_FULL: CampaignsTableColumn[] = [
    CampaignsTableColumn.Actions,
    CampaignsTableColumn.Switch,
    CampaignsTableColumn.CampaignName,
    CampaignsTableColumn.Banners,
    CampaignsTableColumn.ProductType,
    CampaignsTableColumn.Areas,
    CampaignsTableColumn.Budget,
    CampaignsTableColumn.BudgetRemaining,
    CampaignsTableColumn.BudgetSpent,
    CampaignsTableColumn.Bid,
    CampaignsTableColumn.AveragePricePerClick,
    CampaignsTableColumn.Clicks,
    CampaignsTableColumn.Shows,
    CampaignsTableColumn.CTR,
    CampaignsTableColumn.VacancyViews,
    CampaignsTableColumn.Responses,
    CampaignsTableColumn.ResponsesBeforeClickme,
    CampaignsTableColumn.Sources,
    CampaignsTableColumn.BiddingStrategy,
    CampaignsTableColumn.StartAt,
    CampaignsTableColumn.EndAt,
    CampaignsTableColumn.ProfessionalRoles,
    CampaignsTableColumn.CreatedBy,
];

export const CAMPAIGNS_TABLE_COLUMNS_IMPORTANT: CampaignsTableColumn[] = [
    CampaignsTableColumn.Actions,
    CampaignsTableColumn.Switch,
    CampaignsTableColumn.CampaignName,
    CampaignsTableColumn.Banners,
    CampaignsTableColumn.ProductType,
    CampaignsTableColumn.Areas,
    CampaignsTableColumn.Budget,
    CampaignsTableColumn.BudgetRemaining,
    CampaignsTableColumn.Responses,
    CampaignsTableColumn.Bid,
    CampaignsTableColumn.AveragePricePerClick,
];
